import { combineReducers } from '@reduxjs/toolkit';
import {
  addressSlice,
  contactSlice,
  orderSaleItemSlice,
  orderSaleSlice,
  shippingTypeSlice,
} from '@sophocles/features/warehouse/orders/slice';
import {
  customerProductSlice,
  productBomSlice,
  productInventoryLogSlice,
  productInventorySlice,
  productSlice,
  vendorPartSlice,
  vendorSlice,
} from '@sophocles/features/warehouse/products/slice';

// Combining all the reducers
const warehouseReducer = combineReducers({
  addresses: addressSlice.reducer,
  contacts: contactSlice.reducer,
  orderSales: orderSaleSlice.reducer,
  orderSaleItems: orderSaleItemSlice.reducer,
  vendors: vendorSlice.reducer,
  vendorParts: vendorPartSlice.reducer,
  customerProducts: customerProductSlice.reducer,
  shippingTypes: shippingTypeSlice.reducer,
  products: productSlice.reducer,
  productBoms: productBomSlice.reducer,
  productInventories: productInventorySlice.reducer,
  productInventoryLogs: productInventoryLogSlice.reducer,
});

// Exporting the combined reducer
export default warehouseReducer;
